module.exports = __webpack_public_path__ + "926a872e20b6555f4d2a395d6d1bc01e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-LightItalic.ttf
// module id = 1257
// module chunks = 0